var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRealWorldFunding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 265,
    height: 64,
    viewBox: "0 0 260 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 32,
    r: 22,
    stroke: "#FFF",
    strokeWidth: 2,
    fill: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 38,
    cy: 32,
    rx: 22,
    ry: 9,
    stroke: "#FFF",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 38,
    cy: 32,
    rx: 9,
    ry: 22,
    stroke: "#FFF",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 32a22 22 0 0044 0",
    stroke: "#FFF",
    strokeWidth: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 32a22 22 0 0122-22",
    stroke: "#FFF",
    strokeWidth: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 32a22 22 0 00-22-22",
    stroke: "#FFF",
    strokeWidth: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 24 Q33 28 36 22 Q39 18 42 28 Q44 32 48 26",
    stroke: "#FFF",
    strokeWidth: 1,
    fill: "none",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 40 Q37 36 43 42 Q45 44 40 46 Q36 44 34 40",
    stroke: "#FFF",
    strokeWidth: 1,
    fill: "none",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 37,
    fill: "#FFF",
    fontFamily: "Montserrat, Arial, sans-serif",
    fontWeight: "bold",
    fontSize: 27
  }, "REAL WORLD"), /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 57,
    fill: "#FFF",
    fontFamily: "Montserrat, Arial, sans-serif",
    fontSize: 15,
    letterSpacing: 3
  }, "FUNDING"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealWorldFunding);
export default __webpack_public_path__ + "static/media/real-world-funding.f88ef7c3bc57d51cf82ee2bd45360da6.svg";
export { ForwardRef as ReactComponent };